import Page from "../../components/Page";
import CourseListingSection from "../../components/Course/CourseListingSection";
import MenuCoaching from "../../components/MenuCoaching";
const ProviderCourseListingPage = () => {

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <Page>
      <MenuCoaching showBanner={false} />
        <CourseListingSection />
      </Page>
    </>
  );
};
export default ProviderCourseListingPage;
